import { useMutation, gql } from '@apollo/client';
import {
  DeletarFeriadoMutation,
  DeletarFeriadoMutationVariables,
} from './__generated__/DeletarFeriadoMutation';

const DELETAR_FERIADO_MUTATION = gql`
  mutation DeletarFeriadoMutation($id_feriado: Int!) {
    deletarFeriado(id_feriado: $id_feriado) {
      id_feriado
    }
  }
`;

const useDeletarFeriadoMutation = () => {
  return useMutation<DeletarFeriadoMutation, DeletarFeriadoMutationVariables>(
    DELETAR_FERIADO_MUTATION
  );
};

export { useDeletarFeriadoMutation };
